import { apiClient } from '../api'

export interface AdminUser {
  id: string
  name: string
  email: string
  emailVerified: boolean
  isSuperAdmin: boolean
  createdAt: string
  _count?: { memberships: number }
}

export interface AdminUserDetail extends AdminUser {
  memberships: Array<{
    orgId: string
    role: string
    org: { id: string; name: string; slug: string }
  }>
}

export interface AdminOrg {
  id: string
  name: string
  slug: string
  createdAt: string
  _count?: { memberships: number; products: number }
}

export interface AdminOrgDetail extends AdminOrg {
  memberships: Array<{
    id: string
    role: string
    userId: string
    user: { id: string; name: string; email: string }
  }>
  products: Array<{ id: string; name: string; prefix: string }>
}

export async function getAdminUsers(params?: { search?: string; page?: number; limit?: number }): Promise<{ data: AdminUser[]; total: number }> {
  const res = await apiClient.get<{ data: AdminUser[]; total: number }>('/admin/users', { params })
  return res.data
}

export async function getAdminUser(userId: string): Promise<{ data: AdminUserDetail }> {
  const res = await apiClient.get<{ data: AdminUserDetail }>(`/admin/users/${userId}`)
  return res.data
}

export async function updateAdminUser(userId: string, data: { name?: string; email?: string; isSuperAdmin?: boolean }): Promise<{ data: AdminUser }> {
  const res = await apiClient.patch<{ data: AdminUser }>(`/admin/users/${userId}`, data)
  return res.data
}

export async function resetUserPassword(userId: string): Promise<{ data: { sent: boolean } }> {
  const res = await apiClient.post<{ data: { sent: boolean } }>(`/admin/users/${userId}/reset-password`)
  return res.data
}

export async function getAdminOrgs(params?: { search?: string; page?: number; limit?: number }): Promise<{ data: AdminOrg[]; total: number }> {
  const res = await apiClient.get<{ data: AdminOrg[]; total: number }>('/admin/orgs', { params })
  return res.data
}

export async function getAdminOrg(orgId: string): Promise<{ data: AdminOrgDetail }> {
  const res = await apiClient.get<{ data: AdminOrgDetail }>(`/admin/orgs/${orgId}`)
  return res.data
}

export async function updateAdminOrg(orgId: string, data: { name?: string; slug?: string }): Promise<{ data: AdminOrg }> {
  const res = await apiClient.patch<{ data: AdminOrg }>(`/admin/orgs/${orgId}`, data)
  return res.data
}

export async function deleteAdminOrg(orgId: string): Promise<void> {
  await apiClient.delete(`/admin/orgs/${orgId}`)
}

export async function impersonateUser(userId: string): Promise<{ data: { sessionToken: string; user: { id: string; name: string; email: string } } }> {
  const res = await apiClient.post<{ data: { sessionToken: string; user: { id: string; name: string; email: string } } }>(`/admin/impersonate/${userId}`)
  return res.data
}

export async function exitImpersonationApi(adminSessionToken: string): Promise<{ data: { sessionToken: string } }> {
  const res = await apiClient.post<{ data: { sessionToken: string } }>('/admin/impersonate/exit', { adminSessionToken })
  return res.data
}
